import { employeeDocumentUploadDescription as description } from './description';
import { upload as execute } from './execute';

export { description, execute };
